<template>
  <div>
    <v-sheet>
      <v-toolbar flat>
        <v-btn
          outlined
          class="mr-4"
          color="grey darken-2"
          @click="setToday"
          v-if="!$vuetify.breakpoint.xsOnly"
        >
          Today
        </v-btn>
        <v-btn fab text small color="grey darken-2" @click="prev">
          <v-icon small> mdi-chevron-left </v-icon>
        </v-btn>
        <v-btn fab text small color="grey darken-2" @click="next">
          <v-icon small> mdi-chevron-right </v-icon>
        </v-btn>
        <v-toolbar-title
          v-if="$refs.calendar"
          :class="{ 'text-subtitle-1': $vuetify.breakpoint.xsOnly }"
        >
          {{
            $vuetify.breakpoint.xsOnly
              ? $refs.calendar.title.substring(0, 3) +
                " " +
                $refs.calendar.title.slice(-4)
              : $refs.calendar.title
          }}
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-menu bottom right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              color="grey darken-2"
              v-bind="attrs"
              v-on="on"
              :small="$vuetify.breakpoint.xsOnly"
            >
              <span>{{ typeToLabel[type] }}</span>
              <v-icon right> mdi-menu-down </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="type = 'day'">
              <v-list-item-title>Day</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = 'week'">
              <v-list-item-title>Week</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = 'month'">
              <v-list-item-title>Month</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div>
          <v-btn-toggle
            v-if="$vuetify.breakpoint.lgAndUp"
            v-model="toggleAction"
            mandatory
            rounded="xl"
            style="margin-left: 7px"
          >
            <v-btn
              @click="toggleButton(false)"
              style="width: 110px; height: 40px; color: #000000"
            >
              <span class="text-toggle-button">Calendar</span>
            </v-btn>
            <v-btn
              @click="toggleButton(true)"
              style="width: 110px; height: 40px; color: #000000"
            >
              <span class="text-toggle-button">List</span>
            </v-btn>
          </v-btn-toggle>

          <v-btn
            v-else
            fab
            text
            small
            color="grey darken-2"
            @click="toggleButtonSmall"
          >
            <v-icon>{{
              !toggleAction ? "mdi-view-list" : "mdi-calendar"
            }}</v-icon>
          </v-btn>

          <!-- <v-btn fab text small color="grey darken-2" @click="prev">
          <v-icon small> mdi-chevron-left </v-icon>
        </v-btn> -->
        </div>
      </v-toolbar>
    </v-sheet>

    <div
      v-if="!$vuetify.breakpoint.smAndDown && !toggleAction"
      class="d-flex justify-center"
    >
      <div class="d-flex mx-2">
        <div
          class="rounded-circle mr-3 my-auto"
          :style="{
            backgroundColor: getContactTypeColor(0),
            width: '18px',
            height: '18px',
          }"
        ></div>
        <div class="text-caption legend text-sm-body">
          {{ "Birthday" }}
        </div>
      </div>
      <div class="d-flex mx-2" v-for="type in usedContactTypes" :key="type.id">
        <div
          class="rounded-circle mr-3 my-auto"
          :style="{ backgroundColor: getContactTypeColor(type), width: '18px', height: '18px',}"
        ></div>
        <div class="text-caption legend text-sm-body">
          {{ type.name }}
        </div>
      </div>
    </div>

    <v-row>
      <v-col v-if="$vuetify.breakpoint.smOnly" cols="12" sm="12" md="10">
        <snapshot :horizontal="true"></snapshot>
        <div class="d-flex justify-center" v-if="!toggleAction">
          <div class="d-flex mx-2">
            <div
              class="rounded-circle mr-3 my-auto"
              :style="{
                backgroundColor: getContactTypeColor(0),
                width: '14px',
                height: '14px',
              }"
            ></div>
            <div class="text-caption legend text-sm-body">
              {{ "B'day" }}
            </div>
          </div>
          <div
            class="d-flex mx-2"
            v-for="type in usedContactTypes"
            :key="type.id"
          >
            <div
              class="rounded-circle mr-3 my-auto"
              :style="{
                backgroundColor: getContactTypeColor(type),
                width: '14px',
                height: '14px',
              }"
            ></div>
            <div class="text-caption legend text-sm-body">
              {{ type.name.substring(0, 3) }}
            </div>
          </div>
        </div>
      </v-col>
      <v-col v-else cols="12" sm="2" class="p-10 d-flex flex-column">
        <snapshot :horizontal="false"></snapshot>
        <div
          class="d-flex justify-center"
          v-if="$vuetify.breakpoint.smAndDown && !toggleAction"
        >
          <div class="d-flex mx-2">
            <div
              class="rounded-circle mr-3 my-auto"
              :style="{ backgroundColor: getContactTypeColor(0), width: '14px',height: '14px',}"
            ></div>
            <div class="text-caption legend text-sm-body">
              {{ "B'day" }}
            </div>
          </div>
          <div
            class="d-flex mx-2"
            v-for="type in usedContactTypes"
            :key="type.id"
          >
            <div
              class="rounded-circle mr-3 my-auto"
              :style="{ backgroundColor: getContactTypeColor(type), width: '14px',height: '14px',}"
            ></div>
            <div class="text-caption legend text-sm-body">
              {{ type.name.substring(0, 3) }}
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="12" md="10">
        <v-sheet
          :style="{
            height: $vuetify.breakpoint.smAndDown
              ? '80vh'
              : 'calc(100vh - 150px)',
          }"
          class="pt-2 pb-8 mx-4"
          v-show="!toggleAction"
        >
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="events"
            :event-color="getEventColor"
            :type="type"
            :interval-count="12"
            :first-interval="7"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @click:day="dayEvent"
            @change="updateRange"
          ></v-calendar>

          <v-divider />

          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card color="grey lighten-4" min-width="350px" flat>
              <v-toolbar :color="selectedEvent.color" dark>
                <v-btn @click="viewProfile" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- <v-btn icon>
              <v-icon>mdi-heart</v-icon>
            </v-btn> -->
                <!-- <v-btn icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn> -->
              </v-toolbar>
              <v-card-text>
                <span
                  v-if="
                    selectedEvent &&
                    selectedEvent.type == 'expiring' &&
                    selectedEvent.data
                  "
                >
                  {{ selectedEvent.data.requirementName }} expires on
                  {{ selectedEvent.data.certificateExpiresOn | formatDateYear }}
                </span>
                <div
                  v-if="
                    selectedEvent &&
                    selectedEvent.type == 'birthday' &&
                    selectedEvent.data
                  "
                  class="d-flex flex-column"
                >
                  <div v-if="selectedEvent.data.contactTypeName">
                    {{ selectedEvent.data.contactTypeName }}
                  </div>
                  <div class="d-flex flex-space-between">
                    <span class="mr-auto">Date of birth </span>
                    <span>{{ selectedEvent.data.dob | formatDateYear }} </span>
                  </div>
                  <div
                    class="d-flex flex-space-between"
                    v-if="selectedEvent.data.classroomId"
                  >
                    <span class="mr-auto">Classroom </span>
                    <span>{{ selectedEvent.data.classroomName }}</span>
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  class="mx-auto"
                  text
                  color="secondary"
                  @click="selectedOpen = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
        <v-sheet
          :style="{
            height: $vuetify.breakpoint.smAndDown
              ? '80vh'
              : $vuetify.breakpoint.smOnly
              ? '100vh'
              : 'calc(100vh - 150px)',
          }"
          class="pt-2 pb-8"
          v-if="toggleAction"
          style="overflow-y: auto"
          ref="listContainer"
        >
          <list-view
            :start-date="startDate"
            :end-date="endDate"
            :events="events"
            :key="events.length"
            ref="listView"
            class="flex-grow-1"
          ></list-view>
        </v-sheet>
      </v-col>
    </v-row>

    <side-sheet
      v-if="isSideSheetOpen"
      v-model="dayEvent"
      scrollable
      :position="scheduleOverviewPosition"
    >
      <v-sheet ref="sidebarOverview" class="sidebar-overview" elevation="2">
        <div
          style="
            overflow-y: auto;
            overflow-x: hidden;
            height: 100%;
            position: relative;
          "
        >
          <transition :name="nestedTransition">
            <router-view
              class="child-view"
              @close="handleSidePanelClose"
              :eventData="events"
              :date="selectedDate"
            ></router-view>
          </transition>
        </div>
      </v-sheet>
    </side-sheet>
  </div>
</template>
<script>
import { Role } from "@/router/_helper";
import { getAllContactTypes } from "@/services/contactType";
const Snapshot = () => import("@/components/home/Snapshot.vue");

import { mapGetters } from "vuex";
import {
  fetchExpiringStudentCertificates,
  fetchExpiringStaffCertificates,
  fetchBirtdayStudents,
  fetchBirtdayStaff,
  getColor,
} from "@/services/calendarServices.js";
import ListView from "./ListView.vue";
import SideSheet from "../vuetify/SideSheet/SideSheet";

// import Snapshot from './Snapshot.vue';

export default {
  data: () => ({
    focus: "",
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    contactTypes: [],
    toggleAction: localStorage.getItem("calendarToggleAction")
      ? JSON.parse(localStorage.getItem("calendarToggleAction"))
      : false,
    scheduleOverviewPosition: "right",
    startDate: null,
    endDate: null,
    horizontal: null,
    isSideSheetOpen: false,
    selectedDate: null,
    nestedTransition: "slide-left",
  }),

  components: {
    Snapshot,
    ListView,
    SideSheet,
  },

  mounted() {
    this.$refs.calendar.checkChange();

    getAllContactTypes({
      page: 0,
      size: 100,
    }).then((response) => {
      const allContactTypes = response.data.content;
      this.contactTypes = allContactTypes.filter((type) => {
        if (this.hasStaffPermission && type.is_staff) {
          return true;
        }
        if (this.hasStudentPermission && type.is_customer && type.has_student) {
          return true;
        }
      });
    });

    // const storedState = localStorage.getItem('calendarToggleAction');
    // if (storedState !== null) {
    //   this.toggleAction = JSON.parse(storedState);
    //   console.log("tog",this.toggleAction)
    // }
  },

  watch: {
    toggleAction: {
      handler(newValue) {
        localStorage.setItem("calendarToggleAction", JSON.stringify(newValue));
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters("navigation", ["isAppLoading", "globalCenter"]),
    ...mapGetters("auth", ["isLoggedIn", "currentUser", "userRoles"]),
    hasStaffPermission() {
      return (
        this.userRoles.includes(Role.ComplianceStaff) ||
        this.userRoles.includes(Role.Admin)
      );
    },
    hasStudentPermission() {
      return (
        this.userRoles.includes(Role.ComplianceStudent) ||
        this.userRoles.includes(Role.Admin)
      );
    },
    usedContactTypes() {
      //get unique list of used contact type ids
      const contactTypeIds = new Set();
      if (this.events && this.events.length > 0) {
        this.events.forEach((event) =>
          contactTypeIds.add(event.data.contactTypeId)
        );
      }

      return this.contactTypes.filter((type) => contactTypeIds.has(type.id));
    },
  },
  methods: {
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    getContactTypeColor(contactType) {
      const color = getColor(contactType ? contactType.id : 0);
      return color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
      if (this.toggleAction) {
        this.$refs.calendar.checkChange();
      }
    },
    next() {
      this.$refs.calendar.next();
      if (this.toggleAction) {
        this.$refs.calendar.checkChange();
      }
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    async updateRange({ start, end }) {
      this.startDate = start.date;
      this.endDate = end.date;

      // this.events = await fetchRequirementsDue(start.date, end.date, this.globalCenter.id);
      let studentEvents = [];
      let staffEvents = [];
      const locationId = this.globalCenter ? this.globalCenter.id : null;
      if (this.hasStudentPermission) {
        const expiringEvents = await fetchExpiringStudentCertificates(
          end.date,
          locationId
        );
        if (expiringEvents && expiringEvents.length > 0) {
          studentEvents = studentEvents.concat(expiringEvents);
        }

        const birthdayEvents = await fetchBirtdayStudents(start.date, end.date);
        if (birthdayEvents && birthdayEvents.length > 0) {
          studentEvents = studentEvents.concat(birthdayEvents);
        }
      }

      if (this.hasStaffPermission) {
        const expiringEvents = await fetchExpiringStaffCertificates(
          end.date,
          this.globalCenter.id
        );
        if (expiringEvents && expiringEvents.length > 0) {
          staffEvents = staffEvents.concat(expiringEvents);
        }

        const birthdayEvents = await fetchBirtdayStaff(start.date, end.date);
        if (birthdayEvents && birthdayEvents.length > 0) {
          staffEvents = staffEvents.concat(birthdayEvents);
        }
      }

      this.events = [...staffEvents, ...studentEvents];
    },

    viewProfile() {
      if (this.selectedEvent && this.selectedEvent.data) {
        const eventData = this.selectedEvent.data;
        const contactType = this.contactTypes.find(
          (t) => t.id == eventData.contactTypeId
        );

        if (contactType.is_staff) {
          const staffId =
            this.selectedEvent.type == "expiring"
              ? eventData.staffId
              : eventData.id;

          this.$router.push({
            name: "staffView",
            params: { id: staffId },
          });
        } else {
          const studentId =
            this.selectedEvent.type == "expiring"
              ? eventData.studentId
              : eventData.id;

          this.$router.push({
            name: "studentView",
            params: { id: studentId },
          });
        }
      }
    },

    scrollToItemWithDate(targetDate) {
      this.$nextTick(() => {
        const listView = this.$refs.listView;
        if (listView && listView.scrollToItemWithDate) {
          listView.scrollToItemWithDate(targetDate);
        }
      });
    },

    toggleButton(state) {
      this.toggleAction = state;

      localStorage.setItem("calendarToggleAction", JSON.stringify(state));

      if (this.toggleAction) {
        const today = new Date();

        const formattedToday = today.toISOString().split("T")[0];
        this.scrollToItemWithDate(formattedToday);
      }
    },

    toggleButtonSmall() {
      this.toggleAction = !this.toggleAction;
      if (this.toggleAction) {
        const today = new Date();

        const formattedToday = today.toISOString().split("T")[0];
        this.scrollToItemWithDate(formattedToday);
      }
    },

    async dayEvent(event) {
      this.selectedDate = event.date;
      this.isSideSheetOpen = true;
      await this.$router.replace({
        name: "SidePanel",
      });
    },

    handleSidePanelClose() {
      this.isSideSheetOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.treemap {
  svg {
    font: 10px sans-serif;
  }
}

.toggle-btn {
  margin: 5px;
}

.legend {
  white-space: nowrap;
  cursor: pointer;
}

.flex-container {
  display: flex;
}

.flex-item {
  flex: 1;
  padding: 0 10px;
}

.snapshot {
  flex: 1;
}

.calendar {
  flex: 5;
}

.sidebar-overview {
  height: 100%;
  width: 600px;
  margin-right: 0;
  margin-left: 0;
  border-radius: 10px;
  overflow: visible;
  position: relative;
}

@media only screen and (max-width: 960px) {
  .sidebar-overview {
    width: 80%;
  }
}

@media only screen and (max-width: 600px) {
  .sidebar-overview {
    width: 100%;
  }
}

.child-view {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-thumb {
  background-color: #888;
}

// @media only screen and (max-width: 600px) {
//   .calendar-container {
//     margin-left: 20px;
//   }
// }
</style>
